export interface VideoTestimonial {
  name: string
  location: string
  quote: string
  videoUrl: string
}

export interface WrittenTestimonial {
  name: string
  location: string
  photo: string
  quote: string
}

export const videoTestimonial: VideoTestimonial = {
  name: 'Testimonio en video',
  location: 'Cliente de Estados Unidos',
  quote: 'Comparte en sus propias palabras cómo vivió su consulta.',
  videoUrl:
    'https://cdn.magicpatterns.com/uploads/bn3pSECft7P7zdoALeGNrr/video_testimonio.mp4',
}

export const writtenTestimonials: WrittenTestimonial[] = [
  {
    name: 'Carmen R.',
    location: 'Miami, FL',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/b638704f-d55b-47b2-87ee-60555f88ce0d.jpg',
    quote: 'Sentí acompañamiento real en un momento difícil.',
  },
  {
    name: 'María Elena T.',
    location: 'Los Angeles, CA',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/612ba2c6-6e77-4116-996a-de3aef3774e0.jpg',
    quote: 'Me escucharon con respeto y sin juzgarme en ningún momento.',
  },
  {
    name: 'Ernesto M.',
    location: 'Houston, TX',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/7babd6a6-f78c-479b-a54e-ab39eb7ea811.jpg',
    quote: 'Encontré calma y claridad para tomar mis propias decisiones.',
  },
]
